'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDocAsMarkdown;

var _getDocAsJSON = require('./getDocAsJSON');

var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDocAsMarkdown(component) {
  if (!component) {
    throw new Error('getDocAsMarkdown: component is required');
  }

  var documentation = (0, _getDocAsJSON2.default)(component);
  var description = '';
  if (documentation.description) {
    description = '\n' + documentation.description;
  }
  var deprecatedNote = '';
  var deprecatedContent = '';
  if (documentation.deprecated) {
    deprecatedNote = '~~';
    deprecatedContent = '\n### Deprecated: ' + documentation.deprecated;
  }
  var properties = '';
  if (documentation.properties) {
    properties = '\n\n### Properties\n\n| Property | Description | Format | Default Value | Required | Details |\n| ---- | ---- | ---- | ---- | ---- | ---- |';
    documentation.properties.forEach(function (prop) {
      var propDeprecatedNote = '';
      var propDeprecatedContent = '';
      if (prop.deprecated) {
        propDeprecatedNote = '~~';
        propDeprecatedContent = '**Deprecated**: ' + prop.deprecated;
      }
      properties += '\n| **' + propDeprecatedNote + prop.name + propDeprecatedNote + '** | ' + prop.description + ' | ' + prop.format + ' | ' + (prop.defaultValue || '') + ' | ' + (prop.required ? 'Yes' : 'No') + ' | ' + propDeprecatedContent + ' |';
    });
  }
  return '## ' + deprecatedNote + documentation.name + deprecatedNote + ' Component' + deprecatedContent + description + properties;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-desc/lib/getDocAsMarkdown.js
// module id = 589
// module chunks = 0